import PropTypes from 'prop-types';
import React from 'react';
import connect from './connect';
import { isConnected, isContentOffline } from '../selectors/offline';
import OfflineIntercept from './offline_intercept.ui.jsx';
import { swEnabled } from '../engage_cache.js';
import * as routeActions from '../actions/route.js';

function mapStateToProps(state, props) {
    const id = Number(props.params.contentId);

    return {
        isConnected: isConnected(state),
        isContentOffline: isContentOffline(state, id),
    };
}
const connectWrapper = connect(mapStateToProps, routeActions);

export default function offlineIntercept(Component) {
    if (!swEnabled) {
        return Component;
    }

    function Intercept({
        isConnected,
        isContentOffline,
        routeToSection,
        ...rest
    }) {
        if (!isConnected && !isContentOffline) {
            return <OfflineIntercept currentPath={rest.location.pathname} />;
        }

        return <Component {...rest} />;
    }
    Intercept.propTypes = {
        isConnected: PropTypes.bool.isRequired,
        isContentOffline: PropTypes.bool.isRequired,
        routeToSection: PropTypes.func.isRequired,
    };

    return connectWrapper(Intercept);
}



// WEBPACK FOOTER //
// ./src/components/content_intercept.jsx